import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getEntityId } from '../../../../../../../features/helpers/apiHelpers';
import { noSelectionKey } from '../../../../../../../utilities/filterAndSortingsUtil';
import {
  isInvitationGroupInviteePanelOpenSelector,
  isUploadingInvitationGroupInviteesSelector,
  setIsInvitationGroupInviteePanelOpen,
  uploadInvitationGroupInvitees,
} from '../../../../../../../features/pageFeatures/createHearingPageSlice';

export const useUpdateInvitationGroupInvitees = (
  hearingId,
  invitationSource,
) => {
  const dispatch = useDispatch();
  const [selectedInvitationGroupId, setSelectedInvitationGroupId] = useState(
    noSelectionKey,
  );

  const isPanelOpen = useSelector(isInvitationGroupInviteePanelOpenSelector);
  const isUpdating = useSelector(isUploadingInvitationGroupInviteesSelector);

  function onPanelClose() {
    dispatch(setIsInvitationGroupInviteePanelOpen(false));
    setSelectedInvitationGroupId(noSelectionKey);
  }

  function onConfirm() {
    dispatch(
      uploadInvitationGroupInvitees({
        hearingId: hearingId,
        invitationSourceId: getEntityId(invitationSource),
        invitationGroupId: selectedInvitationGroupId,
      }),
    );
  }

  return {
    isPanelOpen,
    onPanelClose,
    selectedInvitationGroupId,
    setSelectedInvitationGroupId,
    onConfirm,
    isUpdating,
  };
};
